/**
 * Notification Constants
 *
 * Constants and utility functions for notifications.
 * Separated from NotificationsModal component to avoid React Fast Refresh warnings.
 */

export interface NotificationItem {
  id: string;
  title: string;
  message: string;
  time: string;
  type: 'call' | 'warning' | 'analytics' | 'event' | 'system';
  isRead: boolean;
  actions?: Array<{
    label: string;
    icon: string;
    onClick: () => void;
  }>;
}

// Default notifications - empty array to remove dummy notification counter
export const defaultNotifications: NotificationItem[] = [];

export const getNotificationIcon = (type: NotificationItem['type']): string => {
  switch (type) {
    case 'call':
      return 'phone';
    case 'warning':
      return 'warning';
    case 'analytics':
      return 'analytics';
    case 'event':
      return 'event';
    case 'system':
      return 'system_update';
    default:
      return 'info';
  }
};

export const getNotificationColor = (type: NotificationItem['type']): string => {
  switch (type) {
    case 'call':
      return 'text-blue-600';
    case 'warning':
      return 'text-yellow-600';
    case 'analytics':
      return 'text-purple-600';
    case 'event':
      return 'text-green-600';
    case 'system':
      return 'text-gray-600';
    default:
      return 'text-blue-600';
  }
};
